import styled from 'styled-components';

export const WaysList = styled.ul`
  position: relative;
  z-index: 5;
  width: 100%;
  
  @media(min-width: 700px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    grid-gap: 30px;
  }
  
  @media(min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
  }
`;

export const WaysItem = styled.li`
  height: 200px;
  
  &:first-child {
    height: 400px;
  }
  
  &:not(:last-child) {
    margin-bottom: 25px;
  }
  
  &:nth-last-child(2),
  &:nth-last-child(3) {
    display: none;
  }
  
  a {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
  
  @media(min-width: 700px) {
    height: 240px;
    
    &:first-child {
      height: auto;
      grid-row: 1 / 3;
    }
    
    &:nth-child(2) {
      grid-row: 1 / 2;
    }
  
    &:not(:last-child) {
      margin-bottom: 0;
    }
  }
  
  @media(min-width: 1024px) {
    height: 200px;
    
    &:first-child {
      grid-row: 1 / 4;
    }
    
    &:nth-child(2) {
      grid-row: 1 / 2;
    }
  
    &:not(:last-child) {
      margin-bottom: 0;
    }
    
    &:nth-last-child(2),
    &:nth-last-child(3) {
      display: block;
    }
  }
  
  @media(min-width: 1120px) {
    &:first-child {
      width: 430px;
    }
  }
`;
